import { inject, Injectable } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { profileStore } from '@core/store';
import { ADMIN_ROUTE_CONSTANTS } from '@shared/constants/routes';

@Injectable({
  providedIn: 'root'
})
class CondominiumRequiredService {
  private store = inject(profileStore);
  private router = inject(Router);

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const condominiums = this.store.data.condominiums();
    const createPath = `/${ADMIN_ROUTE_CONSTANTS.path}/${ADMIN_ROUTE_CONSTANTS.condominium.create.path}`;

    // Si ya está en la ruta de creación de condominio, permitir
    if (state.url === createPath || state.url.startsWith(createPath)) {
      return true;
    }

    // Si no tiene condominios creados, redirigir a la página de creación
    if (!condominiums || condominiums.length === 0) {
      this.router.navigate([createPath]);
      return false;
    }

    return true;
  }
}

export const CondominiumRequiredGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(CondominiumRequiredService).canActivate(next, state);
};
